<!--
* UI Name: Add/Copy/Edit Process
* Modify Date: 2020/10/20
-->
<template>
  <dialog-drag :id="id" :ref="'dialog-' + id" class="mini-view">
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>{{
        options.item.procNm
      }}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->

    <div id="drawflow-cus" class="custom-mini-view"></div>
  </dialog-drag>
</template>

<script>
import Drawflow from 'drawflow';
import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import i18n from '@/locale';
import store from '@/store';
import styleDrawflow from 'drawflow/dist/drawflow.min.css'; // eslint-disable-line no-use-before-define
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';

import IconCom from '@/vue-caas/views/process/component/IconCom.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';

import $ from 'jquery';

export default {
  components: {
    DialogDrag,
    IconSvg,
  },
  props: ['id', 'options', 'removeDialog'],
  IconCom,
  data() {
    return {
      editor: null,
      loadArrProc: [],
    };
  },

  watch: {
    'options.item.id'() {
      // watch it
      this.initialize();
    },
  },
  computed: {},
  mounted() {
    const id = document.getElementById('drawflow-cus');
    this.editor = new Drawflow(id, Vue);
    this.editor.start();

    let self = this;
    this.editor.on('connectionCreated', function(obj) {
      self.editor.removeSingleConnection(
        obj.output_id,
        obj.input_id,
        obj.output_class,
        obj.input_class,
      );
    });

    this.editor.zoom_out();
    this.editor.zoom_out();
    this.editor.zoom_out();

    setTimeout(() => {
      document.getElementsByClassName('overlay-background')[0].style.display = 'none';
    }, 2000);
  },

  created() {
    this.$auth.manage = true;
    this.initialize();
  },

  methods: {
    initialize() {
      const params = {
        procId: this.options.item.id,
        hash: this.$cookies.get('hash'),
      };
      this.$store.dispatch('getProcessDtlListNew', params).then(() => {
        this.loadArrProc = this.$store.getters.processDtlList;
        this.updateComponent();
      });
    },
    registerComponent(componentType, componentId, nodeInfo) {
      const options = {
        store: store,
        i18n: i18n,
        vuetify: vuetify,
      };
      switch (componentType) {
        case 'COM':
          this.editor.registerNode(
            componentType,
            IconCom,
            { btnIcon: 'proc-comm', btnColor: 'miniview darken-1 text-center' },
            options,
          );
          break;
        case 'MAP':
          this.editor.registerNode(
            componentType,
            IconCom,
            {
              btnIcon: 'proc-mapper',
              btnColor: 'miniview darken-1 text-center',
            },
            options,
          );
          break;
        case 'FLT':
          this.editor.registerNode(
            componentType,
            IconCom,
            {
              btnIcon: 'proc-filter',
              btnColor: 'miniview darken-1 text-center',
            },
            options,
          );
          break;
        case 'CVT':
          this.editor.registerNode(
            componentType,
            IconCom,
            {
              btnIcon: 'proc-converter',
              btnColor: 'miniview darken-1 text-center',
            },
            options,
          );
          break;
        case 'API':
          this.editor.registerNode(
            componentType,
            IconCom,
            {
              btnIcon: 'proc-ai',
              btnColor: 'miniview darken-1 text-center',
            },
            options,
          );
          break;
        case 'DIR':
          this.editor.registerNode(
            componentType,
            IconCom,
            {
              btnIcon: 'proc-folder',
              btnColor: 'miniview darken-1 text-center',
            },
            options,
          );
          break;
        case 'USR':
          this.editor.registerNode(
            componentType,
            IconCom,
            {
              btnIcon: 'proc-usr',
              btnColor: 'miniview darken-1 text-center',
            },
            options,
          );
          break;
        case 'TRIG':
          this.editor.registerNode(
            componentType,
            IconCom,
            {
              btnIcon: 'proc-trigger',
              btnColor: 'miniview darken-1 text-center',
            },
            options,
          );
          break;
        case 'GRP':
          this.editor.registerNode(
            componentType,
            IconCom,
            {
              btnIcon: 'proc-group',
              btnColor: 'miniview darken-1 text-center',
            },
            options,
          );
          break;
        case 'DBA':
          this.editor.registerNode(
            componentType,
            IconCom,
            {
              btnIcon: 'proc-dsm',
              btnColor: 'miniview darken-1 text-center',
            },
            options,
          );
          break;
      }
    },
    updateComponent() {
      if (this.loadArrProc.length > 0) {
        let data = { drawflow: { Home: { data: {} } } };
        this.loadArrProc.map((e, i) => {
          let dta = JSON.parse(e.nodeInfo);
          this.registerComponent(e.comTp, e.comId, dta);
          data.drawflow.Home.data[dta.id] = dta;
        });
        this.editor.import(data);
      }
    },
  },
};
</script>

<style>
#drawflow-cus {
  width: 100%;
  height: 500px;
  border: 3px solid #4e686f !important;
}
#drawflow-cus .drawflow .drawflow-node {
  width: 85px !important;
}
.theme-dark #drawflow-cus .drawflow .drawflow-node .input {
  background: #2376ad;
  border-color: #191a21;
}
#drawflow-cus .drawflow .drawflow-node .output {
  right: 10px;
}
#drawflow-cus .drawflow-delete {
  display: none;
}
.dialogs .dialog-drag.mini-view .dialog-body {
  padding-top: 20px !important;
  padding-left: 36px !important;
  padding-right: 36px !important;
  padding-bottom: 20px !important;
}
</style>
